/**
 * Replaces the program meal name token in the button text.
 *
 * @param programMealName - The name of the program meal to insert into the text.
 * @param btnText - The button text containing the token(s) to be replaced.
 * @returns The updated button text with the appropriate token(s) replaced.
 */
export const updateTextIfTokenExists = (programMealName, btnText) => {
    if (!programMealName || !btnText)
        return "";
    return btnText.replace(/\{program-meal-name\}/g, programMealName);
};
/**
 * Get the button text based on the selected meal and configured button texts.
 * @param selectedRecipes - Number of recipes selected.
 * @param meal - Meal object containing Quantity and Name.
 * @param allowAdHocChanges - Whether ad hoc changes are allowed.
 * @param restrictMealQuantitySelection - Whether meal quantity selection is restricted.
 * @param restrictAddRemoveDays - Whether adding or removing days is restricted.
 * @param btnTexts - Object with configured button texts.
 * @returns The appropriate button text based on the conditions.
 */
export const getButtonText = (selectedRecipes, meal, allowAdHocChanges, restrictMealQuantitySelection, restrictAddRemoveDays, btnTexts) => {
    const { Quantity, Name } = meal;
    // Helper to apply token replacement using the meal's Name.
    const updateText = (text) => updateTextIfTokenExists(Name, text);
    // If ad hoc changes are allowed, always return the Skip Meals text.
    if (allowAdHocChanges) {
        return updateText(btnTexts.SkipMealsButtonText);
    }
    // HELPER VARIABLES
    // combined restrictions var for easier condition checking
    const hasNoRestrictions = !restrictMealQuantitySelection && !restrictAddRemoveDays;
    // CONDITIONS FOR ADD ADDITIONAL MEALS OF THE SAME TYPE FOR THIS DAY
    const addMoreConditions = selectedRecipes === Quantity && Quantity > 0 && hasNoRestrictions;
    // CONDITIONS FOR CHANGE THE QUANTITY OF THE MEAL TYPE FOR THIS DAY
    const changeQuantityConditions = selectedRecipes > 0 && selectedRecipes < Quantity && !restrictMealQuantitySelection;
    // CONDITIONS FOR SKIP THIS MEAL TYPE FOR THE SELECTED DAY
    const skipMealsConditions = selectedRecipes === 0 && Quantity > 0 && hasNoRestrictions;
    // CONDITIONS FOR ADD A NEW MEAL TYPE FOR THIS DAY
    const addToOrderConditions = selectedRecipes === 0 && Quantity === 0 && hasNoRestrictions;
    if (addMoreConditions) {
        return updateText(btnTexts.AddMoreMealsButtonText);
    }
    if (changeQuantityConditions) {
        return updateText(btnTexts.MealChangeQuantityButtonText);
    }
    if (skipMealsConditions) {
        return updateText(btnTexts.SkipMealsButtonText);
    }
    if (addToOrderConditions) {
        return updateText(btnTexts.AddToOrderButtonText);
    }
    // Default: return an empty string.
    return "";
};
